import { env } from '@/env';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';
import axiosInstance from '@/utils/axios';

export class FunctionService extends ApiFactory {
  constructor() {
    super('Function');
  }
  /**
   * 發送簡訊
   * @param phone
   * @param content
   * @returns
   */
  sendSms(phone: string, content: string): Promise<ApiDataResponse<boolean>> {
    return super.post(`SendSms?phone=${phone}&content=${content}`, null);
  }
}
